import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {VenuePlanService} from "../venue-plan/venue-plan.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {ErrorHandlerService} from "../../../error-handler.service";
import {VenuePlanData} from "../venue-plan/venue-plan.data";
import {UserData} from "../../auth/user.data";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-plan-management",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-plan-management.component.html",
    styleUrls: ["./venue-plan-management.component.scss"],
    providers: [VenuePlanService],
    standalone: false
})
export class VenuePlanManagementComponent implements OnInit, OnDestroy {

    UserData = UserData;

    editing: boolean;

    data: VenuePlanData;

    lockTierUntilDate: Date;

    useTieredPricing: boolean;

    @Input() loggedUser: UserData;

    preferredFeeModeOptions = [{value: "SIMPLE", label: "Simple"}, {value: "DETAILED", label: "Detailed"}];

    private subscriptions: Subscription = new Subscription();

    constructor(public model: CustomerInstanceVenueModel,
                private errorHandler: ErrorHandlerService,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            this.data = this.model.draft ? this.model.data.venuePlan : Object.assign({}, this.model.data.venuePlan);


            if (this.data.lockTierUntilDate) {
                this.lockTierUntilDate = new Date(this.data.lockTierUntilDate);
            }

            this.useTieredPricing = this.data.pricingTiers && this.data.pricingTiers.length > 0;
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    async save(): Promise<void> {
        if (this.data.planName) {
            try {
                await this.model.updatePlanManagement(this.data);
                this.editing = false;
            } catch (e) {
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.data = Object.assign({}, this.model.data.venuePlan);
        this.editing = false;
    }

    changeFeeCalculation(mode: any): void {
        this.data.preferredFeeCalculationMode = mode.value;
    }

    getSelectedFeeCalculation(): any {
        return this.preferredFeeModeOptions.find(value => value.value === this.data.preferredFeeCalculationMode);
    }

    changeLockTierUntilDate(value: Date): void {
        this.lockTierUntilDate = value;
        if (value) {
            this.data.lockTierUntilDate = this.dateToString(value);
        } else {
            this.data.lockTierUntilDate = undefined;
        }
    }

    dateToString(value: Date): string {
        const month: number = value.getMonth() + 1;
        return value.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-"
            + (value.getDate() < 10 ? "0" : "") + value.getDate();
    }


}
